import { CreateSecretInput30co61ns422r9 as CreateSecretInput } from './schema/type/CreateSecretInput.mjs';
import { CreateSecretMutation3m5frrt825225 as CreateSecretMutation } from './schema/CreateSecretMutation.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Secret2t4auo9luo6wh as Secret } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/Secret.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createSecretInput($this, command) {
  return new (CreateSecretInput())(command.partyId_1, command.description_1);
}
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.execute_csffyb_k$(new (CreateSecretMutation())(createSecretInput(this, command)), $completion)).data_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createSecret_1;
  return tmp1_safe_receiver == null ? null : toDomain(tmp1_safe_receiver);
}
var SdkCreateSecretCommandDispatcherClass;
function SdkCreateSecretCommandDispatcher() {
  if (SdkCreateSecretCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkCreateSecretCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkCreateSecretCommandDispatcherClass = $;
  }
  return SdkCreateSecretCommandDispatcherClass;
}
function toDomain(_this__u8e3s4) {
  return to(new (Secret())(_this__u8e3s4.secretId_1, _this__u8e3s4.description_1, _this__u8e3s4.createdTimestamp_1, _this__u8e3s4.lastUsedTimestamp_1), _this__u8e3s4.secretToken_1);
}
//region block: exports
export {
  SdkCreateSecretCommandDispatcher as SdkCreateSecretCommandDispatcher1ii7hep4t7p2,
  perform as perform1xzhy9m66hc03,
};
//endregion

//# sourceMappingURL=SdkCreateSecretCommandDispatcher.mjs.map
